<template>
  <div class="h-full mx-auto flex justify-center items-center bg-gray-400">

    <div class="bg-white shadow-lg">
      <div class="bg-red-500 p-4 px-8 shadow text-white text-2xl font-semibold">Praksispoolen</div>
      <div class="py-10 px-20">
        <div class="text-center text-3xl font-bold">
          Endre passord
        </div>
        <template v-if="!isChanged">
          <div class="text-center mt-6">
            Passordet må være minst 6 tegn langt.
          </div>
          <form @submit.prevent="onSubmit">
            <div class="flex items-center justify-between mt-12">
              <label for="password" class="font-bold">Nytt passord</label>
              <input type="password" name="password" id="password" autocomplete v-model="password" ref="password" required class="ml-6 w-64">
            </div>
            <div class="flex items-center justify-between mt-6">
              <label for="password2" class="font-bold">Gjenta nytt passord</label>
              <input type="password" name="password2" id="password2" autocomplete v-model="password2" required class="ml-6 w-64">
            </div>
            <div class="p-4 mt-12 bg-red-100 border-2 border-red-300 rounded-lg text-center shadow-lg w-64 mx-auto" v-show="errorMessage">
              {{ errorMessage }}
            </div>
            <div class="text-center mt-12">
              <button type="submit" class="btn btn-primary" :disabled="!isValid">Lagre</button>
            </div>
          </form>
        </template>
        <template v-else>
          <div class="mt-6">Ditt passord er nå oppdatert.</div>
          <div class="mt-12 text-center">
            <router-link class="btn btn-primary" to="/">Til innlogging</router-link>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
export default {
  name: 'change-password',
  props: {
    email: {
      type: String,
      required: true
    },
    keyCode: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isChanged: false,
      password: '',
      password2: '',
      errorMessage: null
    }
  },
  computed: {
    isValid () {
      return this.password.length >= 6 && this.password == this.password2
    }
  },
  methods: {
    async onSubmit () {

      const response = await api.changePassword({
        keyCode: this.keyCode,
        email: this.email,
        password: this.password
      })

      if (response.status === 400) {
        this.errorMessage = 'Kunne ikke nullstille passord. Vennligst prøv igjen.'
      } else {
        this.isChanged = true
      }

    }
  }

}
</script>

